import React from 'react';
import cn from '../../../../../utils/cn';
import { useAgencyInfo } from '../../../AgencyInfoProvider';
import AddressCard from './AddressCard';

function AddressContent({ addressData }) {
    const { showAddressBox, agencyInfoData } = useAgencyInfo();
    return (
        <div
            className={cn(
                `flex gap-10 justify-around mb-5 transition-all duration-[600ms] ease-in-out overflow-hidden`,
                {
                    'max-h-0': !showAddressBox,
                    'max-h-[260px]': showAddressBox
                }
            )}
        >
            <AddressCard
                disabled={agencyInfoData?.status !== 'active'}
                title="administrative"
                addressData={addressData?.administrative}
            />
            <AddressCard
                disabled={agencyInfoData?.status !== 'active'}
                title="billing"
                addressData={addressData?.billing}
            />
            <AddressCard
                disabled={agencyInfoData?.status !== 'active'}
                title="technical"
                addressData={addressData?.technical}
            />
        </div>
    );
}

export default AddressContent;
